<template>
	<div>
		<ts-loading-banner>
			<div class="ts-border ts-p-3 ts-rounded ts-overflow-y-scroll max-h">
				<table class="ts-w-full ts-mt-2 detail">
					<thead>
						<tr>
							<th
								class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-text-center ts-py-2 ts-px-2">
								{{ $t('no') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2">
								{{ $t('sparePartReplacement.barcode') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2">
								{{ $t('sparePartReplacement.productName') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2">
								{{ $t('sparePartReplacement.uom') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2">
								{{ $t('sparePartReplacement.quantity') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2">
								{{ $t('sparePartReplacement.cost') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2">
								{{ $t('sparePartReplacement.technician') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2">
								{{ $t('sparePartReplacement.remark') }}
							</th>
							<th
								class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-w-12 ts-text-center">
								<a href="#" @click.prevent="addNew">
									<i class="fa fa-plus"></i>
								</a>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr class="ts-border-b" v-for="(item, index) in model.product_list" :key="index">
							<td class="ts-text-center ts-p-2">
								{{ index + 1 }}
							</td>
							<td class="ts-p-2 ts-w-56">
								{{ findProduct(item.product_id) ? findProduct(item.product_id).barcode : '' }}
							</td>
							<td class="ts-p-2">
								{{ findProduct(item.product_id) ? findProduct(item.product_id).product_name_en : '' }}
							</td>
							<td class="ts-py-2 ts-px-1">
								<a-select v-model="item.uom_id" class="ts-w-full" style="min-width: 70px"
									:options="getUnitOfMeasures(item.uom_cat_id)" option-filter-prop="children" :class="{
										'is-invalid': errors.has('po_detail.' + index + '.uom_id')
									}" @change="onUomChange(item)">
								</a-select>
							</td>
							<td class="ts-py-2 ts-px-1 ts-w-32">
								<input type="number" class="form-control ts-text-center" v-model.number="item.quantity"
									@input="onChangeQuantity(item)" />
								<div class="invalid-feedback" v-if="errors.has('product_list.' + index + '.quantity')">
									{{ errors.first('product_list.' + index + '.quantity') }}
								</div>
							</td>
							<td class="ts-text-right ts-py-2 ts-px-1 ts-w-32">
								<ts-currency-input type="text" v-model="item.cost" currency="$"
									class="ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2 ts-h-8" />
							</td>
							<td class="ts-w-48 ts-py-2 ts-px-1">
								<a-select v-model.number="item.technician_id" show-search :filter-option="false"
									:options="employees" class="ts-w-full" placeholder="Select">
								</a-select>
								<div class="validate" v-if="errors.has('product_list.' + index + '.technician_id')">
									{{ errors.first('product_list.' + index + '.technician_id') }}
								</div>
							</td>
							<td valign="top" class="ts-py-2 ts-px-1">
								<input ref="remark" v-model.trim="item.remarks" type="text" class="form-control">
							</td>
							<td class="ts-text-center ts-py-2 ts-px-1" valign="middle">
								<a href="#" class="text-red ts-my-auto" @click.prevent="removeRow(index)">
									<i class="fa fa-trash"></i>
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</ts-loading-banner>

		<!-- modal show pop-up to be able add product -->
		<a-modal v-if="show_modal" v-model="show_modal" :footer="null" :zIndex="1020" :maskClosable="false"
			width="800px" :title="$t('stockIn.product')">
			<ProductList v-model="model" />
		</a-modal>
	</div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'

export default {
	name: 'itemDetail',
	props: ['value', 'validate'],
	components: {
		ProductList
	},
	data() {
		return {
			errors: new Errors(),
			show_modal: false,
			model: {},
		}
	},
	async created() {
		this.model = this.value
	},
	computed: {
		...mapState('wholesale/v2/replacement', ['edit_data', 'formViewDatas']),
		products() {
			if (this.formViewDatas['products']) {
				return this.formViewDatas['products']
			}
			return []
		},
		unitOfMeasures() {
			if (this.formViewDatas['unitOfMeasures']) {
				return this.formViewDatas['unitOfMeasures'].map(el => ({
					value: el.uom_id,
					label: el.uom_name_en,
					uom_cat_id: el.uom_cat_id,
					is_default: el.is_default,
					stockout_quantity: el.stockout_quantity
				}))
			}
			return []
		},
		employees() {
			if (this.formViewDatas['employees']) {
				return this.formViewDatas['employees'].map(el => ({
					value: el.employee_id,
					label: el.employee_name_en,
				}))
			}
			return []
		},
	},
	methods: {
		...mapActions('wholesale/v2/replacement', ['find']),
		findProduct(product_id) {
			return this.products.find(el => el.product_id == product_id)
		},
		getUnitOfMeasures(uom_cat_id) {
			return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
		},
		onUomChange(item) {
			const product = this.products.find(el => el.product_id == item.product_id)
			const price = product.sale_code.find(el => el.uom_id == item.uom_id)
			const uom = this.unitOfMeasures.find(el => el.value == item.uom_id)

			item.cost = price ? price.cost : 0
			item.stock_quantity = item.quantity * uom.stockout_quantity
		},
		onChangeQuantity(item) {
			const uom = this.unitOfMeasures.find(el => el.value == item.uom_id)

			item.stock_quantity = item.quantity * uom.stockout_quantity
		},
		addNew() {
			this.show_modal = true
		},
		removeRow(index) {
			this.model.product_list.splice(index, 1)
		},
	},
	watch: {
		validate: function (error) {
			this.errors = new Errors(error.errors)
		}
	}
}
</script>

<style scoped>
.max-h {
	min-height: 30vh;
	max-height: 70vh;
}

table {
	position: relative;
	border-collapse: collapse;
}

th {
	z-index: 7;
	position: sticky;
	top: 0;
}

.form-control {
	height: 32px;
}
</style>